export default __webpack_public_path__ + "static/media/banner-02_644x450_crop_center.46b03b8c.jpg";